import styled from "@emotion/styled";
import { Button, Form, message, Modal, Switch } from "antd";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { useCreateTaxInvoice, useDeleteTaxInvoice } from "hooks/useOrders";
import { CreateTaxInvoiceInput, DeleteTaxInvoiceInput, TaxAddressData } from "services/interface";
import { useAppSelector } from "store";
import CreateTaxAddressForm from "./CreateTaxAddressForm";
import TaxAddressCardList from "./TaxAddressCardList";

interface MainCreateOrderTaxProps {
  dataAddressTax: TaxAddressData[];
  setDataAddressTax: Dispatch<SetStateAction<TaxAddressData[]>>
  // userData?: GetAgentByIdResponse | undefined;
  refId: string;
  refType: string;
  requestTax: boolean;
  setRequestTax: Dispatch<SetStateAction<boolean>>;
  refetchData: () => void;
  addressIdSelected: string;
  setAddressIdSelected: Dispatch<SetStateAction<string>>;
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const MainCreateOrderTax: FC<MainCreateOrderTaxProps> = (
  {
    dataAddressTax,
    setDataAddressTax,
    // userData,
    requestTax,
    setRequestTax,
    refetchData,
    addressIdSelected,
    setAddressIdSelected,
    refId,
    refType
  }) => {

  const { mutate: CreateTaxInvoice } = useCreateTaxInvoice();
  const { mutate: DeleteTaxInvoice } = useDeleteTaxInvoice();

  const [formTax] = Form.useForm();
  const [formEdit] = Form.useForm();

  const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);

  // const [switchValue, setSwitchValue] = useState<boolean>(switchOn);

  useEffect(() => {
    setRequestTax(requestTax);
  }, [requestTax]);

  const showDrawer = () => {
    setOpen(true);
  };

  const onCloseEdit = () => {
    setEdit(false);
    setAddressIdSelected('');
    formEdit.resetFields();
  };

  const onClose = () => {
    setOpen(false);
    formTax.resetFields();
  };

  const handleRemoveItem = (target: string) => {
    const dataInput: DeleteTaxInvoiceInput = {
      tax_invoice_id: target,
    }
    DeleteTaxInvoice(dataInput, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("ลบใบกำกับภาษีสำเร็จ");
          refetchData()
        } else {
          message.error(`สร้างใบกำกับภาษีไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`สร้างใบกำกับภาษีไม่สำเร็จ: ${error.message}`);
      },
    });
  };

  const showEdit = (id: string) => {
    setEdit(true);
    const dataEdit = dataAddressTax.find((item: TaxAddressData) => item.id === id);
    setAddressIdSelected(dataEdit?.id ?? '');
    formEdit.setFieldsValue({
      tax_no: dataEdit?.tax_no,
      name: dataEdit?.name,
      address: dataEdit?.address_text,
      telephone: dataEdit?.telephone,
    });
  };

  const onEdit = (values: any) => {
    const dataRaw: CreateTaxInvoiceInput = {
      tax_invoice_id: addressIdSelected,
      factory_id: factoryId || '',
      ref_id: refId || '',
      ref_type: refType || '',
      tax_no: values.tax_no,
      name: values.name,
      address: values.address,
      telephone: values.telephone
    }

    CreateTaxInvoice(dataRaw, {
      onSuccess: async (res) => {
        if (res.status === "success") {
          message.success("แก้ไขใบกำกับภาษีสำเร็จ");
          onCloseEdit();
          refetchData();
        } else {
          message.error(`แก้ไขใบกำกับภาษีไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`แก้ไขตัวแทนไม่สำเร็จ: ${error.message}`);
      },
    });
  }

  const onFinish = (values: any) => {
    const dataRaw: CreateTaxInvoiceInput = {
      factory_id: factoryId || '',
      ref_id: refId || '',
      ref_type: refType || '',
      tax_no: values.tax_no,
      name: values.name,
      address: values.address,
      telephone: values.telephone
    }

    CreateTaxInvoice(dataRaw, {
      onSuccess: async (res) => {
        if (res.status === "success") {
          message.success("สร้างใบกำกับภาษีสำเร็จ");
          onClose();
          refetchData();
        } else {
          message.error(`สร้างใบกำกับภาษีไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`สร้างใบกำกับภาษีไม่สำเร็จ: ${error.message}`);
      },
    });
  }

  const changeDefault = (id: string) => {
    setAddressIdSelected(id)
  }
  return (
    <>
      <FormWrapper>
        <FormItems
          labelAlign="left"
          label={`ขอใบกำกับภาษี`}
          name="payment_status"
          style={{ fontWeight: "400", marginLeft: '5px' }}
        >
          <Switch
            style={{float:"left"}}
            checked={requestTax}
            onChange={(checked) => setRequestTax(checked)}
          />
        </FormItems>

        {requestTax && (
          <>
            <ButtonWrapper>
              <StyledButton type="primary" onClick={showDrawer}><PlusOutlined /> สร้างที่อยู่ขอใบกำกับภาษี</StyledButton>
            </ButtonWrapper>
            <TaxAddressCardList
              handleRemoveItem={handleRemoveItem}
              showEdit={showEdit}
              dataAddressTax={dataAddressTax}
              setDataAddressTax={setDataAddressTax}
              radio={addressIdSelected}
              changeDefault={changeDefault}
            />
          </>
        )}
      </FormWrapper>

      <Modal
        title="สร้างที่อยู่ใบกำกับภาษี"
        open={open}
        maskClosable={false}
        onCancel={onClose}
        style={{ top: 20 }}
        onOk={() => {
          formTax.submit();
        }}
        cancelText="ยกเลิก" okText="ตกลง"
      >
        <Form form={formTax} {...formItemLayout} onFinish={onFinish}>
          <CreateTaxAddressForm form={formTax} />
        </Form>
      </Modal>

      <Modal
        title="แก้ไขที่อยู่ใบกำกับภาษี"
        open={edit}
        maskClosable={false}
        onCancel={onCloseEdit}
        style={{ top: 20 }}
        onOk={() => {
          formEdit.submit();
        }}
        cancelText="ยกเลิก" okText="ตกลง"
      >
        <Form form={formEdit} {...formItemLayout} onFinish={onEdit}>
          <CreateTaxAddressForm form={formEdit} />
        </Form>
      </Modal>
    </>
  );
};

export default MainCreateOrderTax;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 5px;
  background-color: #ffffffff;
`;

const StyledButton = styled(Button)`
  margin-right: 5px;
`;

const ButtonWrapper = styled.div`
  display:flex;
  justify-content: flex-end;  
  width: 100%;
  height: 100%;
`;

const FormItems = styled(Form.Item)`
  margin-bottom: 10px;
  width:100%
`